import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

import fullLogoImport from '../../assets/static/logos/cohostzone-wordmark-light.svg';
import whiteCompactLogoImport from '../../assets/static/logos/cohostzone-tile-white.svg';
import blackCompactLogoImport from '../../assets/static/logos/cohostzone-tile-espresso.svg';

const getSvgUrl = (imported: any, fallback: string): string => {
  if (typeof imported === 'string') return imported;
  if (imported && typeof imported.default === 'string') return imported.default;
  return fallback;
};

export const FULL_LOGO = getSvgUrl(fullLogoImport, '/static/logos/cohostzone-wordmark-light.svg');
export const BLACK_COMPACT_LOGO = getSvgUrl(blackCompactLogoImport, '/static/logos/cohostzone-tile-espresso.svg');
export const WHITE_COMPACT_LOGO = getSvgUrl(whiteCompactLogoImport, '/static/logos/cohostzone-tile-white.svg');
export const WHITE_FULL_LOGO = getSvgUrl(fullLogoImport, '/static/logos/cohostzone-wordmark-light.svg');

export interface LogoProps {
  sidebarExpanded?: boolean;
  className?: string;
  style?: React.CSSProperties;
  height?: number | string;
  width?: number | string;
}

const Logo: React.FC<LogoProps> = ({
  sidebarExpanded = true,
  className = '',
  style = {},
  height,
  width,
}) => {
  const { theme } = useContext(AuthContext);

  const isDark = theme === 'dark';

  let logoSrc: string;
  let altText: string;

  if (isDark) {
    if (!sidebarExpanded) {
      // 4. Dark Mode + Collapsed -> White Compact Logo (cohostzone-tile-white.svg)
      logoSrc = WHITE_COMPACT_LOGO;
      altText = 'CoHostZone White Compact Logo';
    } else {
      // 3. Dark Mode + Expanded -> White Full Logo (cohostzone-wordmark-light.svg with white filter)
      logoSrc = WHITE_FULL_LOGO;
      altText = 'CoHostZone White Full Logo';
    }
  } else if (!sidebarExpanded) {
    // 2. Light Mode + Collapsed -> Black Compact Logo (cohostzone-tile-espresso.svg)
    logoSrc = BLACK_COMPACT_LOGO;
    altText = 'CoHostZone Black Compact Logo';
  } else {
    // 1. Light Mode + Expanded -> Full Light Logo (cohostzone-wordmark-light.svg)
    logoSrc = FULL_LOGO;
    altText = 'CoHostZone Full Logo';
  }

  const defaultHeight = '40px';
  const defaultMaxHeight = '40px';
  const defaultMaxWidth = !sidebarExpanded ? '40px' : '175px';

  // Apply brightness(0) invert(1) ONLY for Dark Mode + Expanded Full Logo
  // so the dark wordmark text becomes pure bright white on dark background.
  const imageFilter = isDark && sidebarExpanded ? 'brightness(0) invert(1)' : 'none';

  return (
    <img
      src={logoSrc}
      alt={altText}
      className={`obs-logo-img ${className}`}
      style={{
        height: height ?? defaultHeight,
        maxHeight: defaultMaxHeight,
        width: width ?? (!sidebarExpanded ? '40px' : 'auto'),
        maxWidth: defaultMaxWidth,
        objectFit: 'contain',
        transition: 'opacity 0.15s ease-in-out, filter 0.15s ease-in-out',
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: !sidebarExpanded ? '12px' : '0px',
        filter: imageFilter,
        ...style,
      }}
    />
  );
};

export default Logo;


